<template>
    <ChartComponent
        :chartType="'scatter'"
        :options="options"
        :datasets="datasets"
        :labels="labels"
    />
</template>

<script>
import ChartComponent from '@/components/common/chart/ChartComponent.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'GPSChart',
    components: {
        ChartComponent,
    },
    props: {
        options: {
            type: Object,
            default: () => ({}),
        },
        labels: {
            type: Array,
            default: () => [],
        },
        gpsData: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            COLOR_LEVEL_START: [31, 97, 95],
            COLOR_LEVEL_END: [201, 230, 215],
        }
    },
    computed: {
        ...mapGetters(['getGPSPivot']),

        datasets() {
            // 從 Vuex 拿到基準點 (單位：公尺)
            // 雖然名字叫 AvgLongitude/AvgLatitude，但對應的是陣列 0 跟 1 的基準值
            const { AvgLongitude: pivotX, AvgLatitude: pivotY } = this.getGPSPivot()

            // gpsData[0] 是後端的 GPSLatitude (其實是 X 東西向)
            // gpsData[1] 是後端的 GPSLongitude (其實是 Y 南北向)
            const eastingData = this.gpsData[0]?.['data'] || []
            const northingData = this.gpsData[1]?.['data'] || []

            const scatterData = []
            const backgroundColor = []

            // 取最近 4 筆資料進行繪製
            const n = Math.min(eastingData.length, 4)
            for (let i = 0; i < n; i++) {
                const idx = eastingData.length - 1 - i
                const currentX = eastingData[idx]
                const currentY = northingData[idx]

                if (currentX === 0 || currentY === 0) continue

                // 核心邏輯：(目前值 - 基準值) * 100 換算成公分
                scatterData.push({
                    x: (currentX - pivotX) * 100, // 東西向位移
                    y: (currentY - pivotY) * 100, // 南北向位移
                })

                // 越新的資料顏色越深 (i=0 是最新)
                backgroundColor.push(this.getColor((n - 1 - i) / (n - 1)))
            }

            const refPointData = [{ x: 0, y: 0 }]

            return [
                {
                    label: this.$t('scales.gps-label'),
                    data: scatterData,
                    backgroundColor: backgroundColor,
                    borderColor: 'transparent',
                    radius: 6, // 稍微加大點位，更清楚
                },
                {
                    label: this.$t('scales.gps-refpoint'),
                    data: refPointData,
                    // 與空氣品質儀表的「危險」級同色，全站的紅只留這一種
                    backgroundColor: '#C65D6B',
                    borderColor: 'transparent',
                    radius: 5,
                },
            ]
        },
    },
    methods: {
        getColor(progress) {
            const diff = this.COLOR_LEVEL_END.map((v, i) => v - this.COLOR_LEVEL_START[i])
            const color = this.COLOR_LEVEL_START.map((v, i) => {
                return v + parseInt(diff[i] * progress)
            })
            return `#${color.map((v) => v.toString(16).padStart(2, '0')).join('')}`
        },
    },
}
</script>

<style lang="scss" scoped>
/* chart-container 的 style 可視需求保留 */
</style>
